import Environment from './models/Environment'
import { 
  createEnvironment, deleteEnv, 
  loadEnv, makeProduction, loadPublicEnvList,
  updateEnvironment, loadModelBindingsList, loadOverview
} from '@/api/environment'

import { sortBy } from 'lodash'

let envModel = new Environment();

export default {

  namespaced: true,

  state: {
    environment: envModel,
    environments_list: [],
    model_bindings_list: [],
    overview: {
      security_events: {
        failed_logins: 0,
        login: 0,
        brute_force: 0,
        idor: 0
      },
      vulnerable_software: [],
      vulnerable_attributes: [],
      vulnerable_routes: [],
      unclassified_middleware: 0,
      total_route_count: 0,
      model_count: 0,
      middleware_count: 0,
    }
  },

  mutations: {
    ...envModel.mutations(),
    setEnvsList: (state, payload) => state.environments_list = payload,
    setModelBindingsList: (state, payload) => state.model_bindings_list = payload,
    setOverview: (state, payload) => state.overview = payload,
  },

  actions: {
    store: ({}, payload) => new Promise((resolve, reject) => {
      createEnvironment(payload, ({data}) => {
        resolve(data)
      }, error => reject(error))
    }),
    update: ({state}) => new Promise((resolve, reject) => {
      updateEnvironment(state.environment, ({data}) => {
        resolve(data)
      }, error => reject(error))
    }),
    deleteEnv: ({}, envId) => new Promise((resolve, reject) => {
      deleteEnv(envId, ({data}) => {
        resolve(data)
      }, error => reject(error))
    }),
    loadEnv: ({commit}, envId) => new Promise((resolve, reject) => {
      loadEnv(envId, ({data}) => {
        commit('setEnvironment', data)
        resolve(data)
      }, error => reject(error))
    }),
    makeProduction: ({commit}, envId) => new Promise((resolve, reject) => {
      commit('makeProduction')
      makeProduction(envId, ({data}) => {
        resolve(data)
      }, error => reject(error))
    }),
    loadPublicEnvList: ({commit}, appId) => new Promise((resolve, reject) => {
      loadPublicEnvList(appId, ({data}) => {
        commit('setEnvsList', data)
        resolve()
      }, error => reject(error))
    }),
    loadModelBindingsList: ({commit}, envId) => new Promise((resolve, reject) => {
      loadModelBindingsList(envId, ({data}) => {
        commit('setModelBindingsList', data)
        resolve()
      }, error => reject(error))
    }),
    loadOverview: ({commit}, envId) => new Promise((resolve, reject) => {
      loadOverview(envId, ({data}) => {
        commit('setOverview', data)
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    environment: state => state.environment,
    software: state => state.environment.software,
    resolvedVulnerabilities: state => state.environment.vulnerabilities.filter(vul => vul.pivot.is_vulnerable === false),
    unresolvedVulnerabilities: state => state.environment.vulnerabilities.filter(vul => vul.pivot.is_vulnerable === true),
    vulnerabilities: state => state.environment.vulnerabilities,
    environmentsList: state => state.environments_list,
    modelBindingsList: state => sortBy(state.model_bindings_list, 'class_name'),
    environmentAttributes: state => state.environment.attributes.filter(attr => attr.type.type === 'environment'),
    overview: state => state.overview,
  }

}